import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  max-width: 100%;
  height: 100%;
  background-color: #f5f5f5;

  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;

    p {
      margin-top: 16px;
      color: #666;
    }
  }
`;

export const RefreshButton = styled.button`
  background: #fff;
  border: 1px solid #01579b;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #01579b;

  &:active {
    background: ${shade(0.05, '#fff')};
  }
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  .header-buttons {
    display: flex;
    gap: 12px;
  }
`;

export const FilterButton = styled.button`
  background: #01579b;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#01579b')};
  }
`;

export const CameraButton = styled.button`
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#4caf50')};
  }
`;

export const FilterContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .filter-row {
    display: flex;
    gap: 8px;
    margin-bottom: 12px;
  }

  .filter-group {
    flex: 1;

    label {
      display: block;
      margin-bottom: 4px;
      font-size: 14px;
      color: #666;
    }

    input,
    select {
      width: 100%;
      height: 40px;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 0 8px;
    }
  }

  button {
    width: 100%;
    height: 40px;
    background: #01579b;
    color: white;
    border: none;
    border-radius: 4px;
    font-weight: bold;
    transition: background-color 0.2s;

    &:hover {
      background: ${shade(0.2, '#01579b')};
    }
  }
`;

export const CameraModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const CameraContainer = styled.div`
  background: white;
  border-radius: 10px;
  padding: 20px;
  max-width: 100%;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const CameraVideo = styled.video`
  width: 100%;
  max-width: 400px;
  height: auto;
  border-radius: 8px;
  background: #000;
`;

export const CameraControls = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

export const CameraControlButton = styled.button`
  background: #01579b;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#01579b')};
  }

  &.secondary {
    background: #757575;
  }

  &.secondary:hover {
    background: ${shade(0.2, '#757575')};
  }

  &.danger {
    background: #d32f2f;
  }

  &.danger:hover {
    background: ${shade(0.2, '#d32f2f')};
  }
`;

export const CameraTitle = styled.h3`
  color: #01579b;
  margin: 0;
  font-size: 18px;
  text-align: center;
`;

export const SearchContainer = styled.form`
  display: flex;
  margin-bottom: 16px;

  input {
    flex: 1;
    height: 40px;
    border: 1px solid #ddd;
    border-radius: 4px 0 0 4px;
    padding: 0 16px;
  }

  button {
    width: 40px;
    background: #01579b;
    color: white;
    border: none;
    border-radius: 0 4px 4px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;

    &:hover {
      background: ${shade(0.2, '#01579b')};
    }
  }
`;

export const ProtocolList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
  flex: 1;
  overflow-y: auto;
`;

export const ProtocolItem = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 14px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;

  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  .protocol-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .protocol-code {
      font-weight: bold;
      color: #01579b;
    }

    .protocol-date {
      font-size: 12px;
      color: #666;
    }
  }

  .protocol-body {
    margin-bottom: 8px;

    .client-name {
      font-weight: bold;
      margin-bottom: 4px;
    }

    .protocol-desc {
      font-size: 14px;
      color: #666;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .protocol-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;

    .protocol-status {
      font-size: 13px;
      padding: 6px 10px;
      border-radius: 12px;
      background: #e0e0e0;
      display: flex;
      align-items: center;

      &.pendente {
        background: #ffe082;
        color: #b58800;
      }

      &.concluido {
        background: #a5d6a7;
        color: #2e7d32;
      }

      &.cancelado {
        background: #ef9a9a;
        color: #c62828;
      }
    }

    .protocol-method {
      font-size: 13px;
      color: #666;
      font-weight: 500;

      .method-icon {
        display: flex;
        align-items: center;
        gap: 6px;
        background-color: #f5f8fa;
        border-radius: 12px;
        padding: 4px 8px;

        span {
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
  }
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #01579b;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }

  svg {
    font-size: 18px;
  }
`;

export const ProtocolDetail = styled.div`
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.12);

  h3 {
    color: #01579b;
    margin-bottom: 16px;
    font-size: 18px;
  }

  .status-badge {
    display: flex;
    margin-bottom: 20px;
  }

  .info-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;

    p {
      font-size: 14px;

      strong {
        font-weight: bold;
      }

      .method-detail {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background-color: #f5f8fa;
        border-radius: 10px;
        padding: 4px 8px;
        margin-left: 4px;
        font-weight: 500;
      }
    }
  }

  h4 {
    margin-bottom: 8px;
    font-size: 16px;
  }

  ul {
    list-style: none;
    padding: 0;

    li {
      padding: 8px 0;
      border-bottom: 1px solid #eee;
      font-size: 14px;

      &:last-child {
        border-bottom: none;
      }
    }
  }

  .navigation-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #eee;

    .protocol-counter {
      font-size: 15px;
      font-weight: 500;
      color: #555;
    }

    .nav-button {
      background: transparent;
      border: 1.5px solid #01579b;
      color: #01579b;
      padding: 10px 16px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 8px;

      &:disabled {
        opacity: 0.5;
        border-color: #ccc;
        color: #ccc;
      }

      &:active:not(:disabled) {
        background: #f0f8ff;
      }
    }
  }

  .action-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 20px 0;
    padding: 16px 0;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;

    .write-off-button {
      background: #01579b;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 14px 20px;
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      cursor: pointer;
      transition: background-color 0.2s;

      &:active {
        background: #004c8b;
        transform: translateY(1px);
      }

      svg {
        font-size: 18px;
      }
    }
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;

  button {
    flex: 1;
    min-width: 110px;
    background: #01579b;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 12px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    &.secondary {
      background: #757575;
    }

    &.danger {
      background: #d32f2f;
    }

    &.success {
      background: #388e3c;
    }

    &:active {
      background: ${shade(0.2, '#01579b')};
    }

    &.secondary:active {
      background: ${shade(0.2, '#757575')};
    }

    &.danger:active {
      background: ${shade(0.2, '#d32f2f')};
    }

    &.success:active {
      background: ${shade(0.2, '#388e3c')};
    }
  }
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: bold;
  min-width: 100px;
  text-align: center;

  svg {
    font-size: 16px;
    margin-right: 6px;
  }

  &.pendente {
    background: #ffe082;
    color: #b58800;
  }

  &.concluido {
    background: #a5d6a7;
    color: #2e7d32;
  }

  &.cancelado {
    background: #ef9a9a;
    color: #c62828;
  }
`;

export const StatusIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
`;

export const AttachmentsList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top: 16px;
`;

export const AttachmentItem = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #eee;

  .attachment-info {
    display: flex;
    align-items: center;
    gap: 8px;

    span {
      font-size: 14px;
    }
  }

  .attachment-actions {
    display: flex;
    gap: 8px;

    button {
      background: transparent;
      border: none;
      color: #01579b;
      padding: 4px;
    }
  }
`;

export const EmptyMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: #999;

  p {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  button {
    background: #01579b;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 16px;
    font-weight: bold;
    transition: background-color 0.2s;

    &:active {
      background: ${shade(0.2, '#01579b')};
    }
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: auto;
  padding-top: 16px;

  button {
    background: #01579b;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: ${shade(0.2, '#01579b')};
    }

    &:disabled {
      background: #cccccc;
      cursor: default;
    }
  }

  span {
    font-size: 14px;
    color: #666;
  }
`;
